import { Fragment, useContext, useState } from "react";
import { FiltersProvider } from "../../../components/providers/FiltersProvider";
import { menuRoutes } from "../../../router/menu";
import PageHeader from "../../../layout/shared/page-header";
import { PrivilegeContext } from "../../../components/priviledge/PriviledgeProvider";
import { Button } from "rizzui";
import cn from "../../../utils/classNames";
import { UnitMeasure } from "../../../type/entities/unit-measure-type";
import UnitMeasureList from "./UnitMeasureList";

const UnitsMeasureListWrapper = () => {

    // STATES

    const [isOpenFormDrawer, setIsOpenFormDrawer] = useState(false);
    const [unitMeasureSelected, setUnitMeasureSelected] = useState<UnitMeasure | null>(null);

    const breadCrumb = [
        { name: 'Administración' },
        { name: 'Gestión de unidades de medida' },
        { name: 'Unidades de medida', href: menuRoutes.units.path },  
    ];

    const defaultFilters = {};

    // HOOKS

    const { userCan } = useContext(PrivilegeContext);

    // RENDER

    return (
        <Fragment>
            <FiltersProvider defaultFilterFilters={defaultFilters} >
                <PageHeader title="Listado de unidades de medida" breadcrumb={breadCrumb}>
                    {
                        userCan('create', 'category') &&
                        (
                            <Button
                                color="primary"
                                onClick={() => { 
                                    setIsOpenFormDrawer(true) 
                                    setUnitMeasureSelected(null)
                                }}
                                className={cn(['mt-4 md:mt-0'])}
                            >
                                Crear unidad de medida
                            </Button>
                        )
                    }
                </PageHeader>
                <UnitMeasureList openFormDrawer={isOpenFormDrawer} setOpenFormDrawer={setIsOpenFormDrawer} unitMeasureSelected={unitMeasureSelected} setUnitMeasureSelected={setUnitMeasureSelected} />
            </FiltersProvider>
        </Fragment>
    );
};

export default UnitsMeasureListWrapper;